export default __webpack_public_path__ + "static/media/10@2x.fc6b4e0b.png";